// extracted by mini-css-extract-plugin
module.exports = {"switchLabel":"SiteModal_switchLabel__1adVO"};